// Edu Match App
import { type FC } from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route } from 'react-router-dom';

import { useFeatureFlags } from '@core/context/FeatureFlagsContext';
import { selectDcsDegrees } from '@core/reducers/dcsSlice';
import { selectTestResultById } from '@core/reducers/monarchSlice';

import BestMatchExperienceContainer from '../best-match-experience';
import EduResults from '../eduResults/EduResults';
import JoV1EduResults from '../jo-v1/JoV1EduResults';
import JoV2EduResults from '../jo-v2/JoV2EduResults';
import JoV3EduResults from '../jo-v3/JoV3EduResults';
import EduBootcamps from './EduBootcamps';
import EduMatch from './EduMatch';

const EduMatchRouter = () => {
  // eslint-disable-next-line camelcase
  const dcsDegrees = useSelector(selectDcsDegrees);
  const flags = useFeatureFlags();

  const JoExperiencesMap: Record<string, FC> = {
    joV1: JoV1EduResults,
    joV2: JoV2EduResults,
    joV3: JoV3EduResults,
  };

  const joResultsPageRule: string = useSelector((state) => selectTestResultById(state, 'joResultsPageRule'));

  const ResultsComponent = (() => {
    const JOResultsComponent = JoExperiencesMap[joResultsPageRule];

    if (JOResultsComponent) return JOResultsComponent;

    if (dcsDegrees.includes('Bootcamps')) return EduBootcamps;

    if (flags?.bestMatchExperience === 'test') return BestMatchExperienceContainer;
    if (
      (dcsDegrees.includes("Associate's") ||
        dcsDegrees.includes("Bachelor's") ||
        // Test EDU Results page on Grad results page
        flags?.voyagerGradResultsPage === 'test') &&
      !flags?.cypressTest
    ) {
      return EduResults;
    }

    return EduMatch;
  })();

  return (
    <Routes>
      <Route path="/results" element={<ResultsComponent />} />
    </Routes>
  );
};
export default EduMatchRouter;
